module.exports = __webpack_public_path__ + "img/37.3a503b99.png";